import { jsxs as m, jsx as l, Fragment as ue } from "react/jsx-runtime";
import fe from "@jetbrains/icons/chevron-12px-down.js";
import be from "@jetbrains/icons/close-12px.js";
import ge from "@jetbrains/icons/search.js";
import { Button as M } from "@jetbrains/ring-ui-built/components/button/button.js";
import Ce from "@jetbrains/ring-ui-built/components/checkbox/checkbox.js";
import _ from "@jetbrains/ring-ui-built/components/icon/icon.js";
import ke from "@jetbrains/ring-ui-built/components/popup/popup.js";
import Ne from "@jetbrains/ring-ui-built/components/tooltip/tooltip.js";
import i from "classnames";
import ye, { useState as E, useMemo as B, useCallback as o } from "react";
import ve from "react-focus-lock";
import { TOOLTIP_DELAY as Se } from "../../config/globalConstants.js";
import { getAttributeFromTaggedParent as H } from "../../utils/elementAttributes.js";
import { capitaliseStr as Ie, getShortStr as Te } from "../../utils/string.js";
import t from "./Select.module.css.js";
const De = 50, R = () => {
}, Qe = ye.memo((u) => {
  const {
    classNames: O = {},
    defaultSelectionLabel: b = "",
    directions: A,
    disabled: f = !1,
    htmlProps: U = {},
    Icon: Q,
    noChevron: X = !1,
    onClose: g = null,
    onDeleteSelection: I = null,
    onDeselect: x = null,
    onOpen: F = null,
    onSelect: C = null,
    options: h,
    search: P = !1,
    notFoundMessage: Z,
    selected: n,
    selectName: s = "",
    showSelectedTooltip: ee = !0,
    // TODO disabled
    specialButton: k,
    showDisabledChevron: te = !1
  } = u, c = {
    container: "",
    icon: "",
    itemContainer: "",
    label: "",
    list: "",
    listItem: "",
    popup: "",
    labelOpened: "",
    specialButton: "",
    placeholder: "",
    ...O
  }, N = {
    closeBtn: {},
    list: {},
    search: {},
    specialBtn: {},
    triggerBtn: {},
    ...U
  }, r = Array.isArray(n), [le, V] = E(""), [y, T] = E(!1), [v, q] = E(!1), ae = !y && !f && ee, W = B(() => {
    let e = n !== void 0 ? h.filter(
      (a) => (r ? n.includes(a.key) : n === a.key) && !a.disabled
    ).map((a) => a.label) : [];
    return r || (e = e.slice(0, 1)), we(e, De);
  }, [r, h, n]), $ = W || b, Y = B(() => s ? Ie(s) : "", [s]), z = B(() => n !== void 0 ? h.filter(
    (e) => !e.disabled && (r ? n.includes(e.key) : n === e.key)
  ).map((e) => e.label) : [], [h, n, r]), G = B(() => {
    if (n !== void 0) {
      let e;
      return r && n.length === 1 ? e = h.find((a) => a.key === n[0]) : r || (e = h.find((a) => a.key === n)), e?.image;
    }
  }, [h, n, r]), ne = o(
    (e) => {
      V(e.target.value), v && q(!1);
    },
    [v]
  ), S = o(() => {
    T(!1), V(""), g && g();
  }, [g]), ie = o(() => {
    y ? S() : (T(!0), F && F());
  }, [y, F, S]), ce = o(
    (e) => {
      e.key === "Escape" && S();
    },
    [S]
  ), se = o(
    (e) => {
      const a = e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.currentTarget.clientHeight;
      a && v ? q(!1) : !a && !v && q(!0);
    },
    [v]
  ), D = o(
    (e) => {
      const a = H(e.currentTarget, "LI", "data-qd-key"), d = e.currentTarget.getAttribute("data-qd-checked") === "true" || H(e.currentTarget, "SPAN", "data-qd-checked") === "true";
      !d && C && C(a, s), d && x && x(a, s);
    },
    [x, C, s]
  ), oe = o(
    (e) => {
      D(e);
    },
    [D]
  ), re = o(
    (e) => {
      ["Enter", " ", "Spacebar", "Space"].includes(e.key) && D(e);
    },
    [D]
  ), de = o(
    (e) => {
      const a = H(e.currentTarget, "LI", "data-qd-key");
      C && (C(a, s), T(!1), g && g());
    },
    [C, g, s]
  ), me = o(
    (e) => {
      e.preventDefault(), I && I(s);
    },
    [s, I]
  ), he = () => {
    k && (k.onClick(), T(!1));
  }, J = h.filter(
    (e) => e.label.toLowerCase().includes(le.toLowerCase())
  ), pe = (e) => {
    const { key: a, label: d, disabled: p, template: w, image: L, description: j } = e, K = n !== void 0 && n.includes(a);
    return /* @__PURE__ */ l("li", { className: i(t.listItem, c.listItem), "data-qd-key": a, children: r ? (
      // Not a label because we need to prevent two events firing (on input and label), which messes up clicks tracking
      /* @__PURE__ */ m(
        "span",
        {
          "aria-checked": K,
          "aria-disabled": p,
          "aria-label": d,
          className: i(t.itemLabel, c.itemContainer, {
            [t.disabled]: p
          }),
          "data-qd-checked": K,
          onClick: p ? R : oe,
          onKeyDown: p ? R : re,
          role: "checkbox",
          tabIndex: 0,
          title: d,
          children: [
            /* @__PURE__ */ l(
              Ce,
              {
                checked: K,
                containerClassName: t.itemCheckbox,
                disabled: p,
                onChange: R,
                tabIndex: -1,
                title: d
              }
            ),
            L && /* @__PURE__ */ l("div", { className: t.itemIcon, children: L }),
            /* @__PURE__ */ l(
              "span",
              {
                "aria-description": "Item name",
                className: w ? t.itemTemplateContainer : t.itemName,
                children: w || d
              }
            ),
            Object.hasOwn(e, "description") && /* @__PURE__ */ l("span", { "aria-description": "Item description", className: t.itemDesc, children: j })
          ]
        }
      )
    ) : /* @__PURE__ */ l(
      M,
      {
        className: i(t.itemBtn, { [t.disabled]: p }),
        disabled: p,
        onClick: de,
        inline: !0,
        title: d,
        children: /* @__PURE__ */ m(
          "span",
          {
            className: i(t.itemLabel, c.itemContainer, {
              [t.disabled]: p
            }),
            children: [
              L && /* @__PURE__ */ l("div", { className: t.itemIcon, children: L }),
              /* @__PURE__ */ l("span", { className: w ? t.itemTemplateContainer : t.itemName, children: w || d }),
              j && /* @__PURE__ */ l("span", { className: t.itemDesc, children: j })
            ]
          }
        )
      }
    ) }, a);
  };
  return (
    // TODO: Improve a11y. Which role will be better using there?
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ m("div", { className: i(t.container, c.container), onKeyDown: ce, children: [
      /* @__PURE__ */ m(
        Ne,
        {
          delay: Se,
          title: ae && z.length ? z.join(", ") : "",
          children: [
            /* @__PURE__ */ l(
              M,
              {
                className: i(t.label, c.label, {
                  [t.active]: y,
                  [c.labelOpened]: y,
                  [t.disabled]: f
                }),
                disabled: f,
                onClick: ie,
                inline: !0,
                ...N.triggerBtn,
                children: /* @__PURE__ */ m("span", { className: i(t.labelContainer, c.labelContainer), children: [
                  !!Q && /* @__PURE__ */ l(
                    Q,
                    {
                      className: i(t.mainIcon, { [t.disabled]: f }, c.icon)
                    }
                  ),
                  Y && /* @__PURE__ */ m("span", { children: [
                    Y,
                    s && $ && /* @__PURE__ */ l(ue, { children: ": " })
                  ] }),
                  G && /* @__PURE__ */ l(
                    "span",
                    {
                      className: i(
                        t.itemIcon,
                        {
                          [t.itemIconMarginLeft]: s,
                          [t.itemIconDisabled]: f
                        },
                        c.icon
                      ),
                      children: G
                    }
                  ),
                  $ && /* @__PURE__ */ l("span", { className: i({ [c.placeholder]: b && !W }), children: $ }),
                  (!f || te) && !X && /* @__PURE__ */ l("div", { className: i(t.icon, c.chevronIcon), children: /* @__PURE__ */ l(
                    _,
                    {
                      glyph: fe,
                      className: i(t.label, t.chevronDown)
                    }
                  ) })
                ] })
              }
            ),
            /* @__PURE__ */ l(
              ke,
              {
                "data-test": u["data-test"],
                className: i(t.popup, c.popup),
                directions: A,
                hidden: !y,
                onCloseAttempt: S,
                ...N.search,
                children: /* @__PURE__ */ m(ve, { returnFocus: !0, children: [
                  P && /* @__PURE__ */ m("div", { className: t.searchWrapper, children: [
                    /* @__PURE__ */ l(_, { glyph: ge, className: t.searchIcon }),
                    /* @__PURE__ */ l(
                      "input",
                      {
                        autoComplete: "off",
                        placeholder: typeof P == "string" ? P : `Search ${s}`,
                        onChange: ne,
                        ...N.search
                      }
                    )
                  ] }),
                  !J.length && /* @__PURE__ */ l("p", { className: t.empty, children: Z || "No options found" }),
                  /* @__PURE__ */ m("div", { className: t.listContainer, children: [
                    /* @__PURE__ */ l(
                      "ul",
                      {
                        "aria-label": "Select options",
                        role: "listbox",
                        className: i(t.list, c.list),
                        onScroll: se,
                        ...N.list,
                        children: J.map(pe)
                      }
                    ),
                    /* @__PURE__ */ l("div", { className: `${t.fade} ${v ? t.fadeActive : ""}` })
                  ] }),
                  !!k && /* @__PURE__ */ l(
                    M,
                    {
                      inline: !0,
                      className: i(t.specialButton, c.specialButton),
                      onClick: he,
                      disabled: k.disabled,
                      title: k.label,
                      ...N.specialBtn,
                      children: k.label
                    }
                  )
                ] })
              }
            )
          ]
        }
      ),
      n !== void 0 && !!n.length && !f && !!I && /* @__PURE__ */ l(
        "button",
        {
          className: t.icon,
          onClick: me,
          ...N.closeBtn,
          children: /* @__PURE__ */ l(_, { glyph: be })
        }
      )
    ] })
  );
});
function we(u, O) {
  let b = "";
  if (u.length > 1 && (b = `${u.length} selected`), u.length === 1) {
    const A = `${u.join(", ")}`;
    b = Te(A, O);
  }
  return b;
}
export {
  Qe as Select
};
